import { createClient } from '@supabase/supabase-js'

// TODO: Replace with your actual Supabase credentials
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'YOUR_SUPABASE_URL'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY'

 export const supabase = createClient(supabaseUrl, supabaseAnonKey)



// TODO: Replace with your actual Supabase credentials
//const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
//const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Only create client if credentials are provided
// This allows the landing page to work without Supabase setup
//export const supabase = (supabaseUrl && supabaseAnonKey && supabaseUrl.startsWith('http'))
//  ? createClient(supabaseUrl, supabaseAnonKey)
//  : null